import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const get_account_mapping = async () => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(`${APIURL}/get-account-mapping`, config);
    return response?.data;
  } catch (error) {
    return error?.response?.data || {
      status: false,
      message: "Failed to fetch account mapping"
    };
  }
};

const create_update_account_mapping = async (mappingData) => {
  try {
    const data = {
      sales_account: mappingData?.sales_account,
      purchase_account: mappingData?.purchase_account,
      inventory_account: mappingData?.inventory_account,
      sales_return_account: mappingData?.sales_return_account,
      purchase_return_account: mappingData?.purchase_return_account,
      expense_account : mappingData?.expense_account
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/create-update-account-mapping`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error?.response?.data || {
      status: false,
      message: "Failed to save account mapping"
    };
  }
};

const reset_account_mapping = async () => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.delete(
      `${APIURL}/reset-account-mapping`,
      config
    );
    return response?.data;
  } catch (error) {
    return error?.response?.data || {
      status: false,
      message: "Failed to reset account mapping"
    };
  }
};

// Additional controller for getting accounts (for the dropdowns)
const get_all_accounts = async (filters = {}) => {
  try {
    const data = {
      search: filters?.search || "",
      page: filters?.page || 1,
      limit: filters?.limit || 50,
      type: filters?.type || "" // Optional: filter by account type
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/api/accounting/get-all-accounts`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error?.response?.data || {
      status: false,
      message: "Failed to fetch accounts"
    };
  }
};

export {
  get_account_mapping,
  create_update_account_mapping,
  reset_account_mapping
};